import React, { PureComponent } from 'react';
import { Form } from 'react-final-form';
import Breadcrumb, { BreadcrumbItem } from '../../components/Breadcrumb';
import { createAgency, updateAgency } from '../../api/users';
import { getListNations } from '../../api/nations';
import { getListMunicipalities } from '../../api/municipalities';
import AddressFormSection from '../../components/Form/AddressFormSection';
import {
  isEmail,
  isRequired,
  isPasswordValid,
} from '../../utils/validation';
import SavingModal from '../../components/SavingModal';
import Loader from '../../atoms/Loader';
import TextField from '../../components/Form/TextField';
import PasswordField from '../../components/Form/PasswordField';
import EmailField from '../../components/Form/EmailField';
import Tabs from '../../components/Tabs';
import SelectArrayField from '../../components/Field/NewSelectArrayField';

export default class CreateAgencies extends PureComponent {
  state = {
    loading: false,
    openSavingModal: false,
    error: null,
    agencyId: null,
    agency: null,
    nations: [],
    municipalities: [],
  };

  async componentDidMount() {
    try {
      const nationsList = await getListNations();
      const municipalitiesList = await getListMunicipalities();

      const nations = nationsList.map(({ code, name }) => ({
        value: code.toString(),
        label: name,
      }));

      const municipalities = municipalitiesList?.map(({ oldId, name, provincia }) => ({
        value: oldId.toString(),
        label: `${name} (${provincia})`,
      }));

      this.setState({ nations, municipalities });
    } catch (e) {
      console.error(e);
    }
  }

  handleSubmit = async (data) => {
    this.setState({ loading: true });

    try {
      const submitData = {
        ...data,
        username: data.email,
        indirizzo: {
          ...data.indirizzo,
          citta: data.indirizzo.nazione === 'IT'
            ? parseInt(data.indirizzo.citta, 10)
            : undefined,
        },
      };

      if (this.state.agencyId) {
        await updateAgency(this.state.agencyId, submitData);
      } else {
        const { id } = await createAgency(submitData);
        this.props.history.replace(`/admin/agenzie/${id}`);
      }
    } catch (e) {
      const error = typeof e.request !== 'undefined'
        ? JSON.parse(e.request.response)
        : e.getMessage;
      this.setState({
        ...this.state,
        error,
      });
    } finally {
      this.setState({
        ...this.state,
        loading: false,
      });
    }
  };

  closeSavingModal = () => this.setState({ openSavingModal: false });

  render() {
    const { nations, municipalities } = this.state;
    return (
      <>
        <Breadcrumb>
          <BreadcrumbItem to="/admin/agenzie">Agenzie</BreadcrumbItem>
          <BreadcrumbItem>Nuova Agenzia</BreadcrumbItem>
        </Breadcrumb>

        <Tabs tabs={['Agency']}/>

        <Form
          onSubmit={this.handleSubmit}
          initialValues={{
            ...this.state.agency,
            indirizzo: { nazione: 'IT' },
          }}
          render={({
            handleSubmit, submitting, pristine, values,
          }) => (
            <>
              <div className="columns">
                <div className="column is-one-third">
                  <TextField
                    name="ragioneSociale"
                    placeholder="es. Company srl"
                    validate={isRequired}
                    label="Ragione Sociale"
                    errors={this.state.error?.ragioneSociale}
                  />
                </div>
                <div className="column is-one-third">
                  <PasswordField
                    name="password"
                    placeholder="password"
                    validate={isPasswordValid}
                    label="Password"
                    errors={this.state.error?.password}
                  />
                </div>
              </div>

              <div className="columns">
                <div className="column is-one-third">
                  <EmailField
                    name="email"
                    placeholder="es. info@company.net"
                    validate={isEmail}
                    label="Email"
                    errors={this.state.error?.email}
                  />
                </div>
                <div className="column is-one-third">
                  <EmailField
                    name="pec"
                    placeholder="es. company@pec.it"
                    label="PEC"
                    errors={this.state.error?.pec}
                  />
                </div>
                <div className="column is-one-third">
                  <TextField
                    name="sdi"
                    placeholder="Codice SDI"
                    label="Codice SDI"
                    errors={this.state.error?.sdi}
                  />
                </div>
              </div>

              <div className="columns">
                <div className="column is-one-third">
                  <TextField
                    name="pIva"
                    placeholder="es. IT01234567890"
                    label="Partita IVA"
                    errors={this.state.error?.pIva}
                  />
                </div>
                <div className="column is-one-third">
                  <TextField
                    name="codiceFiscale"
                    placeholder="Codice Fiscale"
                    label="Codice Fiscale"
                    errors={this.state.error?.codiceFiscale}
                  />
                </div>
                <div className="column is-one-third">
                  <TextField
                    name="alsiria"
                    placeholder="PCLI"
                    label="PCLI"
                    errors={this.state.error?.alsiria}
                  />
                </div>
              </div>

              <div className="columns">
                <div className="column">
                  <AddressFormSection
                    nations={nations}
                    municipalities={municipalities}
                    values={values}
                  />
                </div>
              </div>

              <footer>
                <div className="field">
                  <div className="control">
                    <button
                      type="submit"
                      onClick={handleSubmit}
                      className="button is-orange is-large"
                      disabled={submitting || pristine}
                    >
                      Salva
                    </button>
                  </div>
                </div>
              </footer>
            </>
          )}
        />

        <SavingModal
          isOpen={this.state.openSavingModal}
          onClose={this.closeSavingModal}
        >
          {this.state.agency
            && `L'utente "${this.state.agency.username}" è stato salvato con successo`}
        </SavingModal>

        {this.state.loading && <Loader/>}
      </>
    );
  }
}
